"use client";
import { type PropsWithChildren } from "react";
import { GoogleReCaptchaProvider as ReCaptchaProvider } from "react-google-recaptcha-v3";

export interface GoogleReCaptchaProviderProps extends PropsWithChildren {
  reCaptchaKey?: string;
}

export function GoogleReCaptchaProvider(props: GoogleReCaptchaProviderProps) {
  const { reCaptchaKey, children } = props;

  if (!reCaptchaKey) {
    return <>{children}</>;
  }

  return (
    <ReCaptchaProvider
      reCaptchaKey={reCaptchaKey}
      scriptProps={{
        async: true,
        defer: true,
        appendTo: "head",
      }}
    >
      {children}
    </ReCaptchaProvider>
  );
}
